import React, { useState } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import FormOriginal from "./form";
import { useAlert } from "react-alert";
import { Redirect } from "react-router-dom";

function Create(props) {
  const [created, setCreated] = useState(false);
  const alert = useAlert();

  const handleSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        Axios.post(baseUrl + "blog", {
          title: values.title,
          body: values.body,
          bannerImage: values.bannerImage,
          description: values.description,
        }).then((response) => console.log(response));
      }
    });
  };
  if (created) {
    alert.success("Urun Basariyla Olusturuldu!");

    return <Redirect to="/blog/list"></Redirect>;
  }
  return <FormOriginal handleSubmit={handleSubmit} type="Create" />;
}

export default Create;
